import { JSX, Show } from "solid-js";
import Text from "./Text";
import { useTranslation } from "../hooks/useTranslation";
import styles from "./BulkActionBar.module.css";

interface BulkActionBarProps {
  selectedCount: number;
  matchingCount: number;
  allMatchingSelected: boolean;
  onSelectAllMatching: () => void;
  onClear: () => void;
  actions: JSX.Element;
}

export function BulkActionBar(props: BulkActionBarProps) {
  const { t } = useTranslation();

  return (
    <Show when={props.selectedCount > 0}>
      <div class={styles.bar}>
        <span class={styles.count}>
          {props.allMatchingSelected
            ? t("BULK_SELECTED_ALL", props.matchingCount)
            : t("BULK_SELECTED", props.selectedCount)}
        </span>

        <Show when={!props.allMatchingSelected && props.matchingCount > props.selectedCount}>
          <span class={styles.scope}>
            <button type="button" class={styles.scopeBtn} onClick={props.onSelectAllMatching}>
              {t("BULK_SELECT_ALL_MATCHING", props.matchingCount)}
            </button>
          </span>
        </Show>

        <div class={styles.actions}>
          {props.actions}
          <button type="button" class="btn btn-secondary btn-sm" onClick={props.onClear}>
            <Text val="BULK_CLEAR" />
          </button>
        </div>
      </div>
    </Show>
  );
}
